<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="6.442" height="8.648" viewBox="0 0 6.442 8.648">
    <path class="a"
          d="M6.762,12.514a.941.941,0,0,1,.059.34.505.505,0,0,1-.153.381.694.694,0,0,1-.493.147H1.023a.694.694,0,0,1-.493-.147.505.505,0,0,1-.153-.381.941.941,0,0,1,.059-.34L2.608,5.3a.731.731,0,0,1,.334-.411,1.27,1.27,0,0,1,.663-.153,1.244,1.244,0,0,1,.651.153.731.731,0,0,1,.334.411Z"
          transform="translate(-0.378 -4.734)"/>
  </svg>
</template>

<script>
export default {
  name: "SortIndicationIcon"
}
</script>

<style scoped>
.a {
  fill: #8ea2a8;
}
</style>
